import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import React, {useEffect, useState} from "react";
import {Col, Row} from "reactstrap";
import {ColumnGroup} from "primereact/columngroup";

const PricingSection = ({localPricing, proposalYear}) => {
    const [feesCat1, setFeesCat1] = useState([]);

    useEffect(() => {
        loadTableDataFromPricingModel();
    }, [localPricing]);

    const loadTableDataFromPricingModel = () => {
        setFeesCat1([
            {
                firstItem: 'Cat 1 Elevator',
                firstItemAmount: localPricing.cat1ElevatorFee,
                secondItem: 'Cat 5 Fees',
                secondItemAmount: localPricing.cat5DeviceFees,
                additionalFee: 'Reschedule',
                amountAdditional: localPricing.rescheduleFee,
                secondaryAdditionalFee: 'Expediting Filing Fee Per Device Per Inspection',
                secondaryAdditionalFeeAmount: localPricing.expeditingFee,
            },
            {
                firstItem: 'Cat 1 Escalator',
                firstItemAmount: localPricing.cat1EscalatorFee,
                secondItem: 'Cat 5 Filing',
                secondItemAmount: localPricing.cat5FilingFee,                
                additionalFee: 'AOC Tracking Fee per device per Inspection',
                amountAdditional: localPricing.aocFee,
                secondaryAdditionalFee: 'QCE Fee Per Device Per QCE',
                secondaryAdditionalFeeAmount: localPricing.qceFee,
            },
            {
                firstItem: 'Cat 1 Lift',
                firstItemAmount: localPricing.cat1LiftFee,
                secondItem: 'Periodic Fee',
                secondItemAmount: localPricing.periodicElevatorFee,
                additionalFee: 'Dismantle Filing',
                amountAdditional: localPricing.dismantleFilingFee,
                secondaryAdditionalFee: 'Dismantle Fee',
                secondaryAdditionalFeeAmount: localPricing.dismantleElevatorFee,
            },
            {
                firstItem: 'Cat 1 Filing',
                firstItemAmount: localPricing.cat1FilingFee,
                secondItem: 'Periodic Filing',
                secondItemAmount: localPricing.periodicFilingFee,
            }
        ]);
    };

    const headerGroup = (
        <ColumnGroup>
            <Row headerStyle={{textAlign: 'center'}}>
                <Column headerStyle={{textAlign: 'center'}} header="Inspection Fees" colSpan={4}/>
                <Column headerStyle={{textAlign: 'center'}} header="Addditional Fees & Services" colSpan={4}/>
            </Row>
        </ColumnGroup>
    );

    const renderAmountColumn = (rowData, options) => {
        let val = rowData[options.field];
        return val ? '$ ' + val : '';
    };

    const footerGroup = (
        <ColumnGroup>
            <Row>
                <Column footer={''} colSpan={6}></Column>
                <Column footer="Contract term:" colSpan={1}/>
                <Column footer={localPricing.contractTerm + ' year'} footerStyle={{textAlign: 'right'}}/>
            </Row>
        </ColumnGroup>
    );

    return (
        <>
            <Row>
                <Col className="text-left" md={12}>
                    <h3>{proposalYear} Pricing (Does not affect your already contracted devices)</h3>
                </Col>
            </Row>

            <div className="card">
                <Row className="card-header">
                    <Col md={12}>
                        <DataTable
                            value={feesCat1}
                            size={'small'}
                            showGridlines={true}
                            showHeaders={true}
                            footerColumnGroup={footerGroup}
                            headerColumnGroup={headerGroup}>
                            <Column style={{width: '13.5%'}}
                                    field="firstItem"></Column>
                            <Column style={{width: '4.5%', textAlign: 'right'}}
                                    body={renderAmountColumn}
                                    field="firstItemAmount"></Column>
                            <Column style={{width: '13.5%'}}
                                    field="secondItem"></Column>
                            <Column style={{width: '4.5%', textAlign: 'right'}}
                                    body={renderAmountColumn}
                                    field="secondItemAmount"></Column>
                            <Column style={{width: '25.5%'}}
                                    field="additionalFee"></Column>
                            <Column style={{width: '4.5%', textAlign: 'right'}}
                                    body={renderAmountColumn}
                                    field="amountAdditional"></Column>
                            <Column style={{width: '25.5%'}}
                                    field="secondaryAdditionalFee"></Column>
                            <Column style={{width: '5.5%', textAlign: 'right'}}
                                    body={renderAmountColumn}
                                    field="secondaryAdditionalFeeAmount"></Column>
                        </DataTable>
                    </Col>
                </Row>
            </div>
        </>
    );
};

export default PricingSection;
